
import { EOemSmsAuditStatus, ESystemType, IOemBrandMeta, IOemDomainMeta, IOemMeta } from '@core/api';
import { UploadUserFile } from 'element-plus';

/** oem有效期*/
export enum EOemTimeType {
  /** 未开始 */
  NotBegin = 1,
  /** 未到期 */
  UnExpired = 2,
  /** 已到期 */
  Expired = 3,
  /** 长期 */
  LongTerm = 4,
  /** 一个月到期 */
  ExpiredOneMonth = 5,
}

export const oemTimeTypeLabel = {
  [EOemTimeType.NotBegin]: '未开始',
  [EOemTimeType.UnExpired]: '未到期',
  [EOemTimeType.Expired]: '已到期',
  [EOemTimeType.LongTerm]: '长期',
  [EOemTimeType.ExpiredOneMonth]: '一个月内到期',
};

export const oemOptds = [
  {
    label: oemTimeTypeLabel[EOemTimeType.NotBegin],
    value: EOemTimeType.NotBegin,
  },
  {
    label: oemTimeTypeLabel[EOemTimeType.UnExpired],
    value: EOemTimeType.UnExpired,
  },
  {
    label: oemTimeTypeLabel[EOemTimeType.Expired],
    value: EOemTimeType.Expired,
  },
  {
    label: oemTimeTypeLabel[EOemTimeType.LongTerm],
    value: EOemTimeType.LongTerm,
  },
  {
    label: oemTimeTypeLabel[EOemTimeType.ExpiredOneMonth],
    value: EOemTimeType.ExpiredOneMonth,
  },
];

/** oem列表传参 */
export interface IOemPageParams {
  /** 业务ID */
  bizId?: string;
  /** 系统类型 */
  sysType?: ESystemType;
  /** 分页 */
  page: number;
  /** 分页数量 */
  size: number;
  /** 是否启用 */
  enabled?: string;
  /** 有效期 */
  validity?: number;
}

/** oem列表返回 */
export interface IOemPage extends IOemMeta {
  /** 业务名称 */
  bizName: string;
  /** 系统类型 */
  sysType?: ESystemType;
}

/** oem新增传参 */
export interface IOemAddParams {
  /** 业务ID */
  bizId: string;
  /** 是否长期有效: 1 是， 0 否 */
  longTerm?: 0 | 1;
  /** 有效期开始时间 */
  validityStartTime: string;
  /** 有效期结束时间 */
  validityEndTime: string;
  /** oemDate*/
  oemDate?: any;
  /** oemId*/
  oemId?: string;
  /** 系统类型 */
  sysType?: ESystemType;
}

export interface IOemAgentOptionsItem {
  /** id */
  bizId: number;
  /** 业务名称 */
  bizName: string;
}

/** oem域名详情 */
export interface IOemDomain extends IOemDomainMeta {
  /** oemId */
  oemId: string;
  /** dnId */
  dnId: string;
}

/** oem域名配置传参 */
export interface IOemDomainAddParams extends IOemDomainMeta {
  /** oemId */
  oemId?: string;
  /** 系统类型 */
  sysType?: ESystemType;
}

/** oem新增品牌传参 */
export interface IOemBrandAddParams extends IOemBrandMeta {
  /** 协议Url列表 */
  agreementList?: UploadUserFile[];
  /** 隐私政策列表 */
  policyList?: UploadUserFile[];
  /** 系统类型 */
  sysType?: ESystemType;
}

/** oem品牌详情返回 */
export interface IOemBrand extends IOemBrandMeta {
  /** dnId */
  dnId: string;
}

/** oem新增短签传参 */
export interface IOemSmsAddParams {
  /** 签名内容 */
  signature: string;
  /** 备注内容 */
  remark: string;
  /** 系统类型 */
  sysType?: ESystemType;
}

/** oem新增短签返回 */
export interface IOemSmsAdd extends IOemSmsAddParams {
  /**
   * 审批状态
   * @description {@link EOemSmsAuditStatus}
   */
  auditStatus: EOemSmsAuditStatus;
  /** 驳回原因 */
  rejectReason: string;
}

/** oem新增 */
export interface IOemManage {
  /** 业务ID */
  bizId?: string;
  /** 有效期 */
  oemDate?: string[];
  /** 是否长期有效 */
  longTerm?: boolean;
  /** oemId */
  oemId?: string;
  /** 业务名称 */
  bizName?: string;
  /** 系统类型 */
  sysType?: ESystemType;
}